import { render, staticRenderFns } from "./CoursewareFolderChooser.vue?vue&type=template&id=045efb54&"
import script from "./CoursewareFolderChooser.vue?vue&type=script&lang=js&"
export * from "./CoursewareFolderChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports